import React from 'react';

import ActionsPauseHighlightedMedium from '@strava/icons/ActionsPauseHighlightedMedium';
import ActionsPlayHighlightedMedium from '@strava/icons/ActionsPlayHighlightedMedium';

import type { FlyoverPlaybackState } from '../../types';

import styles from './PlayPauseIcon.module.scss';

interface PlayPauseIconProps {
  playbackState: FlyoverPlaybackState;
}

export const PlayPauseIcon = ({ playbackState }: PlayPauseIconProps) => (
  <div className={styles.playPauseIcon}>
    {playbackState === 'playing' && (
      <ActionsPlayHighlightedMedium data-testid="playing-icon" />
    )}
    {playbackState === 'paused' && (
      <ActionsPauseHighlightedMedium data-testid="paused-icon" />
    )}
  </div>
);
